import { TextareaHTMLAttributes, forwardRef } from 'react';
import { SxProps } from '@mui/material';

import { StyledTextarea } from './style';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
  disabled?: boolean;
  name?: string;
  sx?: SxProps;
}

const Textarea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { value, className, disabled, name, onChange, ...rest } = props;
  return (
    <StyledTextarea
      {...rest}
      ref={ref}
      name={name}
      disabled={disabled}
      value={value}
      onChange={disabled ? undefined : onChange}
      className={className}
    />
  );
});

export default Textarea;
